export const GET_ALL_BUSINESS = "GET_ALL_BUSINESS";
export const GET_ALL_BUSINESS_SUCCESS = "GET_ALL_BUSINESS_SUCCESS";
export const ADD_NEW_BUSINESS_ITEM = "ADD_NEW_BUSINESS_ITEM";
export const UPDATE_BUSINESS_ITEM = "UPDATE_BUSINESS_ITEM";
export const DELETE_BUSINESS_ITEM = "DELETE_BUSINESS_ITEM";
export const SINGLE_BUSINESS_ITEM = "SINGLE_BUSINESS_ITEM";
export const GET_ALL_BUSINESS_FAILED = "GET_ALL_BUSINESS_FAILED";